"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _role = _interopRequireDefault(require("@/api/system/role"));

var _dept = require("@/api/system/dept");

var _menu = require("@/api/system/menu");

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _UD = _interopRequireDefault(require("@crud/UD.operation"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _vueTreeselect = _interopRequireWildcard(require("@riophae/vue-treeselect"));

require("@riophae/vue-treeselect/dist/vue-treeselect.css");

var _DateRangePicker = _interopRequireDefault(require("@/components/DateRangePicker"));

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var defaultForm = {
  id: null,
  name: null,
  depts: [],
  description: null,
  dataScope: '全部',
  level: 3
};
var _default = {
  name: 'Role',
  components: {
    Treeselect: _vueTreeselect.default,
    pagination: _Pagination.default,
    crudOperation: _CRUD.default,
    rrOperation: _RR.default,
    udOperation: _UD.default,
    DateRangePicker: _DateRangePicker.default
  },
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '角色',
      url: 'api/roles',
      sort: 'level,asc',
      crudMethod: _objectSpread({}, _role.default)
    });
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm), (0, _crud.crud)()],
  data: function data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label',
        isLeaf: 'leaf'
      },
      dateScopes: ['全部', '本级及下属', '本级', '自己', '自定义'],
      level: 3,
      currentId: 0,
      menuLoading: false,
      showButton: false,
      menus: [],
      menuIds: [],
      depts: [],
      deptDatas: [],
      // 多选时使用
      permission: {
        add: ['admin', 'roles:add'],
        edit: ['admin', 'roles:edit'],
        del: ['admin', 'roles:del']
      },
      rules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        permission: [{
          required: true,
          message: '请输入权限',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    var _this2 = this;

    _role.default.getLevel().then(function (data) {
      _this2.level = data.level;
    });
  },
  methods: (_methods = {
    getMenuDatas: function getMenuDatas(node, resolve) {
      setTimeout(function () {
        (0, _menu.getMenusTree)(node.data.id ? node.data.id : 0).then(function (res) {
          resolve(res);
        });
      }, 100);
    }
  }, (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterRefresh, function () {
    this.$refs.menu.setCheckedKeys([]);
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeToAdd, function (crud, form) {
    this.deptDatas = [];
    form.menus = null;
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeToEdit, function (crud, form) {
    this.deptDatas = [];

    if (form.dataScope === '自定义') {
      this.getSupDepts(form.depts);
    }

    var _this = this;

    form.depts.forEach(function (dept) {
      _this.deptDatas.push(dept.id);
    }); // 将角色的菜单清空，避免日志入库数据过长

    form.menus = null;
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterValidateCU, function (crud) {
    if (crud.form.dataScope === '自定义' && this.deptDatas.length === 0) {
      this.$message({
        message: '自定义数据权限不能为空',
        type: 'warning'
      });
      return false;
    } else if (crud.form.dataScope === '自定义') {
      var depts = [];
      this.deptDatas.forEach(function (data) {
        var dept = {
          id: data
        };
        depts.push(dept);
      });
      crud.form.depts = depts;
    } else {
      crud.form.depts = [];
    }

    return true;
  }), (0, _defineProperty2.default)(_methods, "handleCurrentChange", function handleCurrentChange(val) {
    if (val) {
      var _this = this; // 清空菜单的选中


      this.$refs.menu.setCheckedKeys([]); // 保存当前的角色id

      this.currentId = val.id; // 初始化默认选中的key

      this.menuIds = [];
      val.menus.forEach(function (data) {
        _this.menuIds.push(data.id);
      });
      this.showButton = true;
    }
  }), (0, _defineProperty2.default)(_methods, "menuChange", function menuChange(menu) {
    var _this3 = this;

    // 获取该节点的所有子节点，id 包含自身
    (0, _menu.getChild)(menu.id).then(function (childIds) {
      // 判断是否在 menuIds 中，如果存在则删除，否则添加
      if (_this3.menuIds.indexOf(menu.id) !== -1) {
        for (var i = 0; i < childIds.length; i++) {
          var index = _this3.menuIds.indexOf(childIds[i]);

          if (index !== -1) {
            _this3.menuIds.splice(index, 1);
          }
        }
      } else {
        for (var _i = 0; _i < childIds.length; _i++) {
          var _index = _this3.menuIds.indexOf(childIds[_i]);

          if (_index === -1) {
            _this3.menuIds.push(childIds[_i]);
          }
        }
      }

      _this3.$refs.menu.setCheckedKeys(_this3.menuIds);
    });
  }), (0, _defineProperty2.default)(_methods, "saveMenu", function saveMenu() {
    var _this4 = this;

    this.menuLoading = true;
    var role = {
      id: this.currentId,
      menus: []
    }; // 得到已选中的 key 值

    this.menuIds.forEach(function (id) {
      var menu = {
        id: id
      };
      role.menus.push(menu);
    });

    _role.default.editMenu(role).then(function () {
      _this4.crud.notify('保存成功', _crud.default.NOTIFICATION_TYPE.SUCCESS);

      _this4.menuLoading = false;

      _this4.update();
    }).catch(function (err) {
      _this4.menuLoading = false;
      console.log(err.response.data.message);
    });
  }), (0, _defineProperty2.default)(_methods, "update", function update() {
    var _this5 = this;

    // 无刷新更新 表格数据
    _role.default.get(this.currentId).then(function (res) {
      for (var i = 0; i < _this5.crud.data.length; i++) {
        if (res.id === _this5.crud.data[i].id) {
          _this5.crud.data[i] = res;
          break;
        }
      }
    });
  }), (0, _defineProperty2.default)(_methods, "getDepts", function getDepts() {
    var _this6 = this;

    (0, _dept.getDepts)({
      enabled: true
    }).then(function (res) {
      _this6.depts = res.content.map(function (obj) {
        if (obj.hasChildren) {
          obj.children = null;
        }

        return obj;
      });
    });
  }), (0, _defineProperty2.default)(_methods, "getSupDepts", function getSupDepts(depts) {
    var _this7 = this;

    var ids = [];
    depts.forEach(function (dept) {
      ids.push(dept.id);
    });
    (0, _dept.getDeptSuperior)(ids).then(function (res) {
      var date = res.content;

      _this7.buildDepts(date);

      _this7.depts = date;
    });
  }), (0, _defineProperty2.default)(_methods, "buildDepts", function buildDepts(depts) {
    var _this8 = this;

    depts.forEach(function (data) {
      if (data.children) {
        _this8.buildDepts(data.children);
      }

      if (data.hasChildren && !data.children) {
        data.children = null;
      }
    });
  }), (0, _defineProperty2.default)(_methods, "loadDepts", function loadDepts(_ref) {
    var action = _ref.action,
        parentNode = _ref.parentNode,
        callback = _ref.callback;

    if (action === _vueTreeselect.LOAD_CHILDREN_OPTIONS) {
      (0, _dept.getDepts)({
        enabled: true,
        pid: parentNode.id
      }).then(function (res) {
        parentNode.children = res.content.map(function (obj) {
          if (obj.hasChildren) {
            obj.children = null;
          }

          return obj;
        });
        setTimeout(function () {
          callback();
        }, 200);
      });
    }
  }), (0, _defineProperty2.default)(_methods, "changeScope", function changeScope() {
    if (this.form.dataScope === '自定义') {
      this.getDepts();
    }
  }), (0, _defineProperty2.default)(_methods, "checkboxT", function checkboxT(row) {
    return row.level >= this.level;
  }), _methods)
};
exports.default = _default;